<template>
  <div class="p-case-roll" :class="[{ 'is-web': isWeb }]">
    <div class="p-case-roll-box">
      <div v-for="(data, i) in baseData2Split" :key="i">
        <VueSlickCarousel v-bind="i % 2 === 0 ? settings1 : settings2">
          <div class="li" v-for="(item, i) in data" :key="i">
            <div class="li-box">
              <div class="img">
                <img :src="item.icon" alt="" />
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { customData, customData2 } from './config';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import KdIcon from '@/components/KdIcon/index.vue';
import { throttle } from 'lodash';
import { isEnvMobile } from '@/common/utils';
export default {
  name: 'custom-component',
  components: { VueSlickCarousel, KdIcon },
  data() {
    return {
      isWeb: false,
      baseData: customData,
      baseData2: customData2,
      baseData2Split: null,
      settings1: {
        infinite: true,
        centerMode: false,
        centerPadding: '20px',
        slidesToScroll: 1,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        speed: 15000,
        arrows: false,
        cssEase: 'linear',
        draggable: false,
      },
      settings2: {
        infinite: true,
        centerMode: false,
        centerPadding: '20px',
        slidesToScroll: 1,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        speed: 15000,
        arrows: false,
        cssEase: 'linear',
        rtl: true,
        draggable: false,
      },
    };
  },
  methods: {
    onWindowResize: throttle(function () {
      const result = [];
      let chunkSize = 0; // 每个子数组的大小
      const _clientWidth = window.document.documentElement.clientWidth;
      if (_clientWidth > 1264) {
        // 4行列
        chunkSize = 16;
      } else if (_clientWidth > 840) {
        // 5行列
        chunkSize = 12;
      } else if (_clientWidth > 375) {
        // 8行列
        chunkSize = 10;
      }
      for (let i = 0; i < this.baseData2.length; i += chunkSize) {
        result.push(this.baseData2.slice(i, i + chunkSize));
      }
      this.baseData2Split = result;
    }, 500),
  },

  mounted() {
    this.isWeb = isEnvMobile();
    this.onWindowResize();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>

<style lang="scss" scoped>
.p-case-roll {
  max-width: 1200px;
  width: 100%;
  margin: 72px auto 0 auto;
  position: relative;
  &.is-web {
    margin: px2rem(80) auto px2rem(20) auto;
    .p-case-roll-box {
      width: 100%;
      min-height: px2rem(333);
      position: relative;
      margin: 0 auto;
      padding-left: 2%;
      background: #fff;
      :deep(.slick-slide) {
        margin: 0;
      }
      &::before,
      &::after {
        content: '';
        width: px2rem(50);
        height: 100%;
        background-image: linear-gradient(
          270deg,
          hsla(0, 0%, 100%, 0),
          #fff 67%
        );
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
      &::after {
        right: 0px;
        left: auto;
        transform: rotate(-180deg);
      }
      .li {
        width: auto !important;
        height: px2rem(74);
        padding: px2rem(12) px2rem(24);
        display: inline-block;
        border-radius: px2rem(8);
        border: 1px solid rgba(0, 0, 0, 0.12);
        margin: px2rem(12);
        background: #fff;
        &-box {
          width: 100%;
          height: 100%;
          background-color: white;
          text-align: center;
          display: flex;
          align-items: center;
          .img {
            width: px2rem(120);
            height: auto;
            img {
              width: 100%;
              height: 100%;
              display: inline-block;
            }
          }
          p {
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
            margin-top: 8px;
          }
        }
      }
    }
  }

  &-box {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    :deep(.slick-slide) {
      margin: 0 24px 24px 24px;
    }
    &::before,
    &::after {
      content: '';
      width: 30%;
      height: 100%;
      background-image: linear-gradient(270deg, hsla(0, 0%, 100%, 0), #fff 67%);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      @media screen and (max-width: $width-xl) {
        width: 100px;
      }
    }
    &::after {
      right: 0px;
      left: auto;
      transform: rotate(-180deg);
    }
    .li {
      width: auto !important;
      height: 64px;
      padding: 12px 24px;
      display: inline-block;
      border-radius: 8px;
      border: 1px solid rgba(0, 0, 0, 0.12);
      &-box {
        width: 100%;
        height: 100%;
        background-color: white;
        text-align: center;
        .img {
          width: auto;
          height: 40px;
          img {
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        }
        p {
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #000000;
          margin-top: 8px;
        }
      }
    }
  }
}

@include responsiveV2($width-m) {
  .p-case-roll {
    &-box {
      max-width: 840px;
      width: 100%;
    }
  }
}
</style>
